import React from 'react'
import injectSheet from 'react-jss'
import styles from './pobble-link.styles'
import classNames from 'classnames'

const PobbleLink = ({ as = 'a', classes, className, children, ...props }) => {
  const Component = as
  return (
    <Component className={classNames(classes.link, className)} {...props}>
      {children}
    </Component>
  )
}

export default injectSheet(styles)(PobbleLink)
